<template>
  <Teleport to="body">
    <div v-if="visible" class="image-viewer-overlay" @click="handleHide">
      <div class="image-viewer-content" @click.stop>
        <div class="image-viewer-header">
          <button class="image-viewer-close" @click="handleHide">&times;</button>
        </div>
        <div class="image-viewer-body">
          <img 
            v-if="currentImage" 
            :src="currentImage" 
            :alt="'Image'"
            class="image-viewer-img"
            @click="nextImage"
          />
          <div v-if="imgs.length > 1" class="image-viewer-nav">
            <button @click="prevImage" class="nav-btn">&lt;</button>
            <span class="image-counter">{{ currentIndex + 1 }} / {{ imgs.length }}</span>
            <button @click="nextImage" class="nav-btn">&gt;</button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imgs: {
      type: Array,
      default: () => []
    }
  },
  emits: ['hide'],
  data() {
    return {
      currentIndex: 0
    }
  },
  computed: {
    currentImage() {
      return this.imgs[this.currentIndex] || ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.currentIndex = 0
      }
    }
  },
  methods: {
    handleHide() {
      this.$emit('hide')
    },
    nextImage() {
      if (this.imgs.length > 1) {
        this.currentIndex = (this.currentIndex + 1) % this.imgs.length
      }
    },
    prevImage() {
      if (this.imgs.length > 1) {
        this.currentIndex = this.currentIndex === 0 ? this.imgs.length - 1 : this.currentIndex - 1
      }
    }
  }
}
</script>

<style scoped>
.image-viewer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.image-viewer-content {
  max-width: 95%;
  max-height: 95%;
  position: relative;
}

.image-viewer-header {
  position: absolute;
  top: -40px;
  right: 0;
  z-index: 10000;
}

.image-viewer-close {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: white;
}

.image-viewer-close:hover {
  color: #ccc;
}

.image-viewer-body {
  text-align: center;
}

.image-viewer-img {
  max-width: 100%;
  max-height: 80vh;
  cursor: pointer;
}

.image-viewer-nav {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.nav-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.nav-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.image-counter {
  color: white;
  font-size: 0.9rem;
}
</style>
